export const productKeys = {
  'claro:topup': 'Claro recarga',
  'claro:dataplan': 'Claro paquetico',
  'claro:pin': 'Claro pin',
  'claro:invoice': 'Claro factura',
  'altice:topup': 'Altice recarga',
  'altice:dataplan' : 'Altice paquetico',
  'altice:pin': 'Altice pin',
  'altice:invoice': 'Altice factura',
  'viva:topup': 'Viva recarga',
  'viva:dataplan': 'Viva paquetico',
  'viva:pin': 'Viva pin',
  'viva:invoice': 'Viva factura',
  'digicel:topup': 'Digicel recarga',
  'digicel:dataplan': 'Digicel paquetico',
  'natcom:topup': 'Natcom recarga',
  'moun:topup': 'Noum recarga',
  'wind:dataplan': 'Wind paquetico',
  'wind:invoice': 'Wind factura',
  'activa:topup': 'Activa recarga',
  'edenorte:topup': 'Edenorte recarga',
  'edenorte:invoice': 'Edenorte factura',
  'edesur:topup': 'Edesur recarga',
  'edesur:invoice': 'Edesur factura',
  'edeeste:invoice': 'Edeeste factura',
  'cepm:topup': 'CEPM recarga',
  'cepm:invoice': 'CEPM factura',
  'ceb:topup': 'CEB recarga',
  'ceb:invoice': 'CEB factura',
  'pasorapido:topup': 'Paso Rápido',
  'coraasan:invoice': 'Coraasan',
  'coraaplata:invoice': 'Coraaplata',
  'coraavega:invoice': 'Coraavega',
  'coaarom:invoice': 'Coaarom',
  'caasd:invoice': 'CAASD',
  'inapa:invoice': 'Inapa',
  'aster:invoice': 'Aster',
  'adn:invoice': 'ADN',
  'asdn:invoice': 'ASDN',
  'dgii:invoice': 'DGII',
  'pgr:invoice': 'PGR multas',
  'tss:invoice': 'TSS',
  'midas:insurance': 'Midas seguros',
  'star-sport:topup': 'Star Sport Recarga',
  'betcris:topup': 'Betcris Recarga',
  'juancito-sport:topup': 'Juancito Sport Recarga',
  'unknown': 'Ningura'
};

export const productKeyList = Object
  .entries(productKeys)
  .map(([key, value]) => ({ key, value }));
